import React, { useState } from "react";
import { Switch, Route, useLocation, Redirect } from "react-router-dom";
import { paths } from "pages/App/helpers/paths";
import { questionTypes } from "pages/App/helpers/questionTypes";
import AllResults from "pages/PanelPage/components/selectedAssessment/assessmentResults/AllResults";
import TakerResults from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/TakerResults";
import TakerResultsbyType from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/TakerResultsbyType";

const AssessmentResults = () => {
  const resultsPath = `${paths.ADMIN}/:assessment/results`;
  const [chartData, setChartData] = useState({});
  const { pathname } = useLocation();

  return (
    <Switch>
      <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
      <Route exact path={resultsPath}>
        <AllResults chartData={chartData} setChartData={setChartData} />
      </Route>
      <Route exact path={`${resultsPath}/:attemptUUID/upload_results`}>
        <TakerResultsbyType type={questionTypes.UPLOAD} />
      </Route>
      <Route exact path={`${resultsPath}/:attemptUUID/mcq_results`}>
        <TakerResultsbyType type={questionTypes.SELECT} />
      </Route>
      <Route path={`${resultsPath}/:attemptUUID`}>
        <TakerResults chartData={chartData} setChartData={setChartData} />
      </Route>
    </Switch>
  );
};

export default AssessmentResults;
